export const FLAG = {
  // Default flag aspect ratio
  WIDTH: 1920,
  HEIGHT: 1080,

  // Default flag start coordinates
  START_X: 0,
  START_Y: 0,
};
